<template>
    <SliceZone :components="components" :slices="article?.data?.slices" />
</template>

<script lang="ts" setup>
    import {ref, inject} from 'vue';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData, useWebsitePageView} from '#imports';
    import {PRISMIC_DOCUMENT} from '~/app/keys';
    import usePrismicDocument from '~/composables/content/usePrismicDocument';
    import {useResolvePrismicDocument} from '~/composables/content/useResolvePrismicDocument';
    import {useDocumentMetadata} from '~/composables/useDocumentMetadata';
    import {components} from '~/slices/components';
    const document = inject(PRISMIC_DOCUMENT, ref());

    const {data, error} = await useAsyncData('homepage', () => usePrismicDocument('resourcesCenterHome'));
    const article = useResolvePrismicDocument(data, error);

    document.value = article.value;

    if (article.value) {
        useDocumentMetadata(article.value);
    }

    useWebsitePageView('resources-center', 'homepage');
</script>
